import type { Blocker } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useIntakeMessages } from "./intake-messages";

export function TicketIntakeLeaveDialog({ blocker, pending }: { blocker: Blocker; pending: boolean }) {
  const m = useIntakeMessages();

  return (
    <AlertDialog
      open={blocker.state === "blocked"}
      onOpenChange={(open) => {
        if (!open) blocker.reset?.();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.leaveTitle}</AlertDialogTitle>
          <AlertDialogDescription>{m.leaveDescription}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button">{m.keepEditing}</AlertDialogCancel>
          <AlertDialogAction
            type="button"
            disabled={pending}
            onClick={(event) => {
              event.preventDefault();
              blocker.proceed?.();
            }}
          >
            {m.discardAndLeave}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
